import React from 'react';
import about from '../images/about_org.jpg';
import consulting from '../images/consulting.avif';
import { useDocTitle } from '../components/CustomHook';
import CommonContainer from "../components/CommonContainer";
import { commonStyles } from "../pages/commonStyles";
function Consulting() {
  useDocTitle("Consulting");

  return (
    <div>
      {/* Hero Section */}
    <div className="relative overflow-hidden mt-4 lg:mt-0 h-[320px] md:h-[380px] lg:h-[450px]">
        {/* Background image */}
        <div className="absolute inset-0 z-0">
          <img
            src={about}
            alt="Background"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-50 z-10"></div>

        {/* Content */}
       <div className="relative z-20 h-full flex items-center justify-center text-center text-white">
 <h2 className={`${commonStyles.pageTitle} text-white`}>
    Consulting
  </h2>
</div>
      </div>
<CommonContainer>
      {/* Section Title */}
      {/* <div className="mt-16">
        <p className="font-bold text-blue-500 mb-6 text-center
                      text-lg md:text-xl lg:text-2xl">
          Consulting
        </p>
      </div> */}

      {/* Main Content */}
     <div className="flex flex-col lg:flex-row items-center my-8 gap-8 lg:gap-12">

        {/* Image */}
        <div className="w-full lg:w-1/2 my-5">
          <img
            src={consulting}
            alt="Consulting"
            className="w-full h-auto object-cover rounded-lg shadow-lg"
          />
        </div>

        {/* Text */}
      <div className="lg:w-1/2">

  <h1 className={`${commonStyles.heading} mb-6`}>
    Consulting
  </h1>

 <p className={`${commonStyles.paragraph} mb-4`}>
    The QuadProsoft consulting team comprises senior IT and management leads,
    offering an average of about eight years of experience per team. Our typical
    consulting team, deployed to study a situation and deliver a solution,
    comprises people who bring with them expertise and experience in operational
    efficiency, strategic IT / business convergence, and process architecture.
  </p>

 <p className={`${commonStyles.paragraph} mb-4`}>
    This combination has always proved useful, especially in the initial phases
    of the project, when the customer's requirements are systematically studied.
  </p>

</div>
      </div>

      {/* Extra Description */}
     <div className="mt-10">

  <p className={`${commonStyles.paragraph} mb-4`}>
    Based on this study, our designated SPOC offers an analysis which,
    following a discussion with the leaders from the client team, leads to a
    proposed solution which can then be deployed using a combination of
    onsite, offsite, and offshore delivery.
  </p>

  <div className="mt-10">
    <ul className="space-y-6 ml-10">
      {[
        "IT Infrastructure",
        "SOA and Application Development",
        "Open-source technologies",
      ].map((item) => (
        <li
          key={item}
          className="flex items-start text-[18px] leading-8 text-gray-600"
        >
          <span className="text-green-500 text-xl mr-3 mt-1">✔</span>
          {item}
        </li>
      ))}
    </ul>
  </div>

  <div className="mt-10">
   <p className={`${commonStyles.paragraph} mb-4`}>
      To find out more about our consulting capabilities, please{" "}
      <a href="/contact" className="text-blue-500 hover:underline">
        contact us
      </a>.
    </p>
  </div>

</div>
      </CommonContainer>
    </div>
  );
}

export default Consulting;
